import { createGlobalStyle } from "styled-components"
import { Settings } from "./theme"

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 15px;
    @media screen and (min-width: ${Settings.sizeS}) and (max-width: ${Settings.sizeM}) {
      font-size: 13px;
    }
    @media screen and (min-width: ${Settings.sizeXS}) and (max-width: ${Settings.sizeS}) {
      font-size: 12px;
    }
    @media screen and (max-width: ${Settings.sizeXS}) {
      font-size: 11px;
    }
  }

  body {
    font-family: 'Poppins', 'Helvetica', sans-serif;
    font-weight: 300;
    margin: 0 ;
    overflow-x: hidden;
  }

  .constraint{
    width: 90%;
    max-width: 1024px;
    margin: 0 auto;
  }
  h1,h2,h3,h4,h5,h6 {
    font-weight: 300;
    > b {
      font-weight: 700;
    }
  }

  h1,h2,h3 {
    font-weight: 700;
  }
  
  a {
    color: ${Settings.primaryColor}

    > h1,h2,h3,h4,h5,h6{
      font-weight: 400;
    }
  }

  .orange {
    color: ${Settings.primaryColor}
  }

  .white {
    color: #fff;
  }

  .blue {
    color: ${Settings.secondaryColor}
  }

  .hide-on-medium {
    @media screen and (max-width: ${Settings.sizeM}) {
      display: none;
    }
  }
  
  .show-on-medium {
    display: block;
    @media screen and (min-width: ${Settings.sizeM}) {
      display: none;
    }
  }

  p {
    opacity: 0.9;
  }

  h6 {
    font-size: 1rem;
  }
  h6 > a {
    text-decoration: none;
    position: relative;
    letter-spacing: 0.2rem;
    &:after {
      content: "";
      position: absolute;
      bottom: -0.5rem;
      left: 0;
      width: 70%;
      background: ${Settings.primaryColor};
      height: 2px;
      transition: transform 125ms ease-in-out;
      transform-origin: center left;
      transform: scaleX(0.2);
    }
    &:hover {
      &:after {
        transform: scaleX(1);
      }
    }
  }

`

export default GlobalStyle
